import { Typography } from "@material-ui/core";
import React from "react";

function TermsConditions(props) {
  return (
    <React.Fragment>
      <Typography paragraph variant="h5">
        Privacy Policy
      </Typography>
      <Typography paragraph variant="body1">
        Updated at 2022-02-02
      </Typography>
      <Typography paragraph variant="body1">
        Invifo. ("we," "our," or "us") is committed to protecting your privacy.
        This Privacy Policy explains how your personal information is collected,
        used, and disclosed by Invifo. This Privacy Policy applies to our
        website, https://invifo.com , and its associated subdomains
        (collectively, our "Service"). By accessing or using our Service, you
        signify that you have read, understood, and agree to our collection,
        storage, use, and disclosure of your personal information as described
        in this Privacy Policy and our Terms of Service.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Definitions and key terms
      </Typography>
      <Typography paragraph variant="body1">
        To help explain things as clearly as possible in this Privacy Policy,
        every time any of these terms are referenced, are strictly defined as:
      </Typography>
      <Typography paragraph variant="body1">
        <ul>
          <li>
            <b>Cookie</b>: small amount of data generated by a website and saved
            by your web browser. It is used to identify your browser, provide
            analytics, remember information about you such as your language
            preference or login information.
          </li>
          <li>
            <b>Company</b>: when this policy mentions "Company," "we," "us," or
            "our," it refers to Invifo Technology International, Level 11, One
            Pacific Place, Sudirman Central Business District, Kav 52 - 53,
            Jakarta Selatan 12190, Indonesia that is responsible for your
            information under this Privacy Policy.
          </li>
          <li>
            <b>Country</b>: where Invifo or the owners/founders of Invifo are
            based, in this case is Indonesia.
          </li>
          <li>
            <b>Customer</b>: refers to the company, organization or person that
            signs up to use the Invifo Service to manage the relationships with
            your consumers or service users.
          </li>
          <li>
            <b>Device</b>: any internet connected device such as a phone,
            tablet, computer or any other device that can be used to visit
            Invifo and use the services.
          </li>
          <li>
            <b>IP address</b>: Every device connected to the Internet is
            assigned a number known as an Internet protocol (IP) address. These
            numbers are usually assigned in geographic blocks. An IP address can
            often be used to identify the location from which a device is
            connecting to the Internet.
          </li>
          <li>
            <b>Personnel</b>: refers to those individuals who are employed by
            Invifo or are under contract to perform a service on behalf of one
            of the parties.
          </li>
          <li>
            <b>Personal Data</b>: any information that directly, indirectly, or
            in connection with other information — including a personal
            identification number — allows for the identification or
            identifiability of a natural person.
          </li>
          <li>
            <b>Service</b>: refers to the service provided by Invifo as
            described in the relative terms (if available) and on this platform.
          </li>
          <li>
            <b>Third-party service</b>: refers to advertisers, contest sponsors,
            promotional and marketing partners, and others who provide our
            content or whose products or services we think may interest you.
          </li>
          <li>
            <b>Website</b>: Invifo's site, which can be accessed via this URL:
            https://invifo.com.
          </li>
          <li>
            <b>You</b>: a person or entity that is registered with Invifo to use
            the Services.
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        What Information Do We Collect?
      </Typography>
      <Typography paragraph variant="body1">
        We collect information from you when you visit our service, register,
        place an order, subscribe to our newsletter, respond to a survey or fill
        out a form.
      </Typography>
      <Typography paragraph variant="body1">
        <ul>
          <li>Name / Username</li>
          <li>Phone Numbers</li>
          <li>Email Addresses</li>
          <li>Mailing Addresses</li>
          <li>Job Titles</li>
          <li>Billing Addresses</li>
          <li>Debit/credit card numbers</li>
          <li>Age</li>
          <li>Password</li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        We also collect information from mobile devices for a better user
        experience, although these features are completely optional.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How Do We Use The Information We Collect?
      </Typography>
      <Typography paragraph variant="body1">
        Any of the information we collect from you may be used in one of the
        following ways:
      </Typography>
      <Typography paragraph variant="body1">
        <ul>
          <li>
            To personalize your experience (your information helps us to better
            respond to your individual needs)
          </li>
          <li>
            To improve our service (we continually strive to improve our service
            offerings based on the information and feedback we receive from you)
          </li>
          <li>
            To improve customer service (your information helps us to more
            effectively respond to your customer service requests and support
            needs)
          </li>
          <li>To process transactions </li>
          <li>
            To administer a contest, promotion, survey or other site feature
          </li>
          <li>To send periodic emails</li>
        </ul>
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        When do we use customer information from third parties?
      </Typography>
      <Typography paragraph variant="body1">
        We receive some information from the third parties when you contact us.
        For example, when you submit your email address to us to show interest
        in becoming our customer, we receive information from a third party that
        provides automated fraud detection services to us. We also occasionally
        collect information that is made publicly available on social media
        websites. You can control how much of your information social media
        websites make public by visiting these websites and changing your
        privacy settings.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Do we share the information we collect with third parties?
      </Typography>
      <Typography paragraph variant="body1">
        We may share the information that we collect, both personal and
        non-personal, with third parties such as advertisers, contest sponsors,
        promotional and marketing partners, and others who provide our content
        or whose products or services we think may interest you. We may also
        share it with our current and future affiliated companies and business
        partners, and if we are involved in a merger, asset sale or other
        business reorganization, we may also share or transfer your personal and
        non-personal information to our successors-in-interests.
      </Typography>
      <Typography paragraph variant="body1">
        We may engage trusted third party service providers to perform functions
        and provide services to us, such as hosting and maintaining our servers
        and our service, database storage and management, e-mail management,
        storage marketing, credit card processing, customer service and
        fulfilling orders for products and services you may purchase through our
        platform. We will likely share your personal information, and possibly
        some non-personal information, with these third parties to enable them
        to perform these services for us and for you.
      </Typography>
      <Typography paragraph variant="body1">
        We may share portions of our log file data, including IP addresses, for
        analytics purposes with third parties such as web analytics partners,
        application developers, and ad networks. If your IP address is shared,
        it may be used to estimate general location and other technographics
        such as connection speed, whether you have visited the service in a
        shared location, and type of device used to visit the service. They may
        aggregate information about our advertising and what you see on the
        service and then provide auditing, research and reporting for us and our
        advertisers.
      </Typography>
      <Typography paragraph variant="body1">
        We may also disclose personal and non-personal information about you to
        government or law enforcement officials or private parties as we, in our
        sole discretion, believe necessary or appropriate in order to respond to
        claims, legal process (including subpoenas), to protect our rights and
        interests or those of a third party, the safety of the public or any
        person, to prevent or stop any illegal, unethical, or legally actionable
        activity, or to otherwise comply with applicable court orders, laws,
        rules and regulations.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Where and when is information collected from customers and end users?
      </Typography>
      <Typography paragraph variant="body1">
        We will collect personal information that you submit to us. We may also
        receive personal information about you from third parties as described
        above.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How Do We Use Your Email Address?
      </Typography>
      <Typography paragraph variant="body1">
        By submitting your email address on this website, you agree to receive
        emails from us. You can cancel your participation in any of these email
        lists at any time by clicking on the opt-out link or other unsubscribe
        option that is included in the respective email. We only send emails to
        people who have authorized us to contact them, either directly, or
        through a third party. We do not send unsolicited commercial emails,
        because we hate spam as much as you do. By submitting your email
        address, you also agree to allow us to use your email address for
        customer audience targeting on sites like Facebook, where we display
        custom advertising to specific people who have opted-in to receive
        communications from us. Email addresses submitted only through the order
        processing page will be used for the sole purpose of sending you
        information and updates pertaining to your order. If, however, you have
        provided the same email to us through another method, we may use it for
        any of the purposes stated in this Policy. Note: If at any time you
        would like to unsubscribe from receiving future emails, we include
        detailed unsubscribe instructions at the bottom of each email.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Could my information be transferred to other countries?
      </Typography>
      <Typography paragraph variant="body1">
        We are incorporated in Indonesia. Information collected via our website,
        through direct interactions with you, or from use of our help services
        may be transferred from time to time to our offices or personnel, or to
        third parties, located throughout the world, and may be viewed and
        hosted anywhere in the world, including countries that may not have laws
        of general applicability regulating the use and transfer of such data.
        To the fullest extent allowed by applicable law, by using any of the
        above, you voluntarily consent to the trans- border transfer and hosting
        of such information.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Is the information collected through our service secure?
      </Typography>
      <Typography paragraph variant="body1">
        We take precautions to protect the security of your information. We have
        physical, electronic, and managerial procedures to help safeguard,
        prevent unauthorized access, maintain data security, and correctly use
        your information. However, neither people nor security systems are
        foolproof, including encryption systems. In addition, people can commit
        intentional crimes, make mistakes or fail to follow policies. Therefore,
        while we use reasonable efforts to protect your personal information, we
        cannot guarantee its absolute security. If applicable law imposes any
        non-disclaimable duty to protect your personal information, you agree
        that intentional misconduct will be the standards used to measure our
        compliance with that duty.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Can I update or correct my information?
      </Typography>
      <Typography paragraph variant="body1">
        The rights you have to request updates or corrections to the information
        we collect depend on your relationship with us. Personnel may update or
        correct their information as detailed in our internal company employment
        policies. Customers have the right to request the restriction of certain
        uses and disclosures of personally identifiable information as follows.
        You can contact us in order to (1) update or correct your personally
        identifiable information, (2) change your preferences with respect to
        communications and other information you receive from us, or (3) delete
        the personally identifiable information maintained about you on our
        systems (subject to the following paragraph), by cancelling your
        account. Such updates, corrections, changes and deletions will have no
        effect on other information that we maintain, or information that we
        have provided to third parties in accordance with this Privacy Policy
        prior to such update, correction, change or deletion. To protect your
        privacy and security, we may take reasonable steps (such as requesting a
        unique password) to verify your identity before granting you profile
        access or making corrections. You are responsible for maintaining the
        secrecy of your unique password and account information at all times.
        You should be aware that it is not technologically possible to remove
        each and every record of the information you have provided to us from
        our system. The need to back up our systems to protect information from
        inadvertent loss means that a copy of your information may exist in a
        non-erasable form that will be difficult or impossible for us to locate.
        Promptly after receiving your request, all personal information stored
        in databases we actively use, and other readily searchable media will be
        updated, corrected, changed or deleted, as appropriate, as soon as and
        to the extent reasonably and technically practicable. If you are an end
        user and wish to update, delete, or receive any information we have
        about you, you may do so by contacting the organization of which you are
        a customer.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Personnel
      </Typography>
      <Typography paragraph variant="body1">
        If you are one of our workers or applicants, we collect information you
        voluntarily provide to us. We use the information collected for Human
        Resources purposes in order to administer benefits to workers and screen
        applicants. You may contact us in order to (1) update or correct your
        information, (2) change your preferences with respect to communications
        and other information you receive from us, or (3) receive a record of
        the information we have relating to you Such updates, corrections,
        changes and deletions will have no effect on other information that we
        maintain, or information that we have provided to third parties in
        accordance with this Privacy Policy prior to such update, correction,
        change or deletion.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Sale of Business
      </Typography>
      <Typography paragraph variant="body1">
        We reserve the right to transfer information to a third party in the
        event of a sale, merger or other transfer of all or substantially all of
        the assets of us or any of its Corporate Affiliates (as defined herein),
        or that portion of us or any of its Corporate Affiliates to which the
        Service relates, or in the event that we discontinue our business or
        file a petition or have filed against us a petition in bankruptcy,
        reorganization or similar proceeding, provided that the third party
        agrees to adhere to the terms of this Privacy Policy.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Affiliates
      </Typography>
      <Typography paragraph variant="body1">
        We may disclose information (including personal information) about you
        to our Corporate Affiliates. For purposes of this Privacy Policy,
        "Corporate Affiliate" means any person or entity which directly or
        indirectly controls, is controlled by or is under common control with
        us, whether by ownership or otherwise. Any information relating to you
        that we provide to our Corporate Affiliates will be treated by those
        Corporate Affiliates in accordance with the terms of this Privacy
        Policy.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How Long Do We Keep Your Information?
      </Typography>
      <Typography paragraph variant="body1">
        We keep your information only so long as we need it to provide service
        to you and fulfill the purposes described in this policy. This is also
        the case for anyone that we share your information with and who carries
        out services on our behalf. When we no longer need to use your
        information and there is no need for us to keep it to comply with our
        legal or regulatory obligations, we'll either remove it from our systems
        or depersonalize it so that we can't identify you.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How Do We Protect Your Information?
      </Typography>
      <Typography paragraph variant="body1">
        We implement a variety of security measures to maintain the safety of
        your personal information when you place an order or enter, submit, or
        access your personal information. We offer the use of a secure server.
        All supplied sensitive/credit information is transmitted via Secure
        Socket Layer (SSL) technology and then encrypted into our Payment
        gateway providers database only to be accessible by those authorized
        with special access rights to such systems, and are required to keep the
        information confidential. After a transaction, your private information
        (credit cards, social security numbers, financials, etc.) is never kept
        on file. We cannot, however, ensure or warrant the absolute security of
        any information you transmit to us or guarantee that your information on
        the Service may not be accessed, disclosed, altered, or destroyed by a
        breach of any of our physical, technical, or managerial safeguards.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Governing Law
      </Typography>
      <Typography paragraph variant="body1">
        The laws of Indonesia, excluding its conflicts of law rules, shall
        govern this Agreement and your use of our service. Your use of our
        service may also be subject to other local, state, national, or
        international laws.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Your Consent
      </Typography>
      <Typography paragraph variant="body1">
        By using our service, registering an account, or making a purchase, you
        consent to this Privacy Policy.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Links to Other Websites
      </Typography>
      <Typography paragraph variant="body1">
        This Privacy Policy applies only to the Services. The Services may
        contain links to other websites not operated or controlled by Invifo. We
        are not responsible for the content, accuracy or opinions expressed in
        such websites, and such websites are not investigated, monitored or
        checked for accuracy or completeness by us. Please remember that when
        you use a link to go from the Services to another website, our Privacy
        Policy is no longer in effect. Your browsing and interaction on any
        other website, including those that have a link on our platform, is
        subject to that website's own rules and policies. Such third parties may
        use their own cookies or other methods to collect information about you.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Cookies
      </Typography>
      <Typography paragraph variant="body1">
        We use "Cookies" to identify the areas of our website that you have
        visited. A Cookie is a small piece of data stored on your computer or
        mobile device by your web browser. We use Cookies to personalize the
        Content that you see on our website. Most web browsers can be set to
        disable the use of Cookies. However, if you disable Cookies, you may not
        be able to access functionality on our website correctly or at all. We
        never place Personally Identifiable Information in Cookies.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Remarketing Services
      </Typography>
      <Typography paragraph variant="body1">
        We use remarketing services. What Is Remarketing? In digital marketing,
        remarketing (or retargeting) is the practice of serving ads across the
        internet to people who have already visited your website. It allows your
        company to seem like they're "following" people around the internet by
        serving ads on the websites and platforms they use most.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Payment Details
      </Typography>
      <Typography paragraph variant="body1">
        In respect to any credit card or other payment processing details you
        have provided us, we commit that this confidential information will be
        stored in the most secure manner possible.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Kids' Privacy
      </Typography>
      <Typography paragraph variant="body1">
        We do not address anyone under the age of 13. We do not knowingly
        collect personally identifiable information from anyone under the age of
        13. If You are a parent or guardian and You are aware that Your child
        has provided Us with Personal Data, please contact Us. If We become
        aware that We have collected Personal Data from anyone under the age of
        13 without verification of parental consent, We take steps to remove
        that information from our servers.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Changes To Our Privacy Policy
      </Typography>
      <Typography paragraph variant="body1">
        If we decide to change our privacy policy, we will post those changes on
        this page, and/or update the Privacy Policy modification date below.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Third-Party Services
      </Typography>
      <Typography paragraph variant="body1">
        We may display, include or make available third-party content (including
        data, information, applications and other products services) or provide
        links to third-party websites or services ("Third- Party Services").
      </Typography>
      <Typography paragraph variant="body1">
        You acknowledge and agree that we shall not be responsible for any
        Third-Party Services, including their accuracy, completeness,
        timeliness, validity, copyright compliance, legality, decency, quality
        or any other aspect thereof. We do not assume and shall not have any
        liability orresponsibility to you or any other person or entity for any
        Third-Party Services.
      </Typography>
      <Typography paragraph variant="body1">
        Third-Party Services and links thereto are provided solely as a
        convenience to you and you access and use them entirely at your own risk
        and subject to such third parties' terms and conditions.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Tracking Technologies
      </Typography>
      <Typography paragraph variant="body1">
        <b>Google Maps APIs</b>
        <br />
        Google Maps API is a robust tool that can be used to create a custom
        map, a searchable map, check-in functions, display live data synching
        with location, plan routes, or create a mashup just to name a few.
        Google Maps API may collect information from You and from Your Device
        for security purposes. Google Maps API collects information that is held
        in accordance with its Privacy Policy
      </Typography>
      <Typography paragraph variant="body1">
        <b>Cookies</b>
        <br />
        We use Cookies to enhance the performance and functionality of our
        service but are non-essential to their use. However, without these
        cookies, certain functionality like videos may become unavailable or you
        would be required to enter your login details every time you visit our
        service as we would not be able to remember that you had logged in
        previously.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Local Storage</b>
        <br />
        Local Storage sometimes known as DOM storage, provides web apps with
        methods and protocols for storing client-side data. Web storage supports
        persistent data storage, similar to cookies but with a greatly enhanced
        capacity and no information stored in the HTTP request header.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Sessions</b>
        <br />
        We use "Sessions" to identify the areas of our website that you have
        visited. A Session is a small piece of data stored on your computer or
        mobile device by your web browser.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Information about General Data Protection Regulation (GDPR)
      </Typography>
      <Typography paragraph variant="body1">
        We may be collecting and using information from you if you are from the
        European Economic Area (EEA), and in this section of our Privacy Policy
        we are going to explain exactly how and why is this data collected, and
        how we maintain this data under protection from being replicated or used
        in the wrong way.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        What is GDPR?
      </Typography>
      <Typography paragraph variant="body1">
        GDPR is an EU-wide privacy and data protection law that regulates how EU
        residents' data is protected by companies and enhances the control the
        EU residents have, over their personal data.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        What is personal data?
      </Typography>
      <Typography paragraph variant="body1">
        Any data that relates to an identifiable or identified individual. GDPR
        covers a broad spectrum of information that could be used on its own, or
        in combination with other pieces of information, to identify a person.
        Personal data extends beyond a person's name or email address. Some
        examples include financial information, political opinions, genetic
        data, biometric data, IP addresses, physical address, sexual
        orientation, and ethnicity. The Data Protection Principles include
        requirements such as:
      </Typography>
      <Typography paragraph variant="body1">
        <ul>
          <li>
            Personal data collected must be processed in a fair, legal, and
            transparent way and should only be used in a way that a person would
            reasonably expect.
          </li>
          <li>
            Personal data should only be collected to fulfil a specific purpose
            and it should only be used for that purpose. Organizations must
            specify why they need the personal data when they collect it.
          </li>
          <li>
            Personal data should be held no longer than necessary to fulfil its
            purpose.
          </li>
          <li>
            People covered by the GDPR have the right to access their own
            personal data. They can also request a copy of their data, and that
            their data be updated, deleted, restricted, or moved to another
            organization.
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Why is GDPR important?
      </Typography>
      <Typography paragraph variant="body1">
        GDPR adds some new requirements regarding how companies should protect
        individuals' personal data that they collect and process. It also raises
        the stakes for compliance by increasing enforcement and imposing greater
        fines for breach. Beyond these facts it's simply the right thing to do.
        At Help Scout we strongly believe that your data privacy is very
        important and we already have solid security and privacy practices in
        place that go beyond the requirements of this new regulation.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Individual Data Subject's Rights - Data Access, Portability and Deletion
      </Typography>
      <Typography paragraph variant="body1">
        We are committed to helping our customers meet the data subject rights
        requirements of GDPR. We process or store all personal data in fully
        vetted, DPA compliant vendors. We do store all conversation and personal
        data for up to 6 years unless your account is deleted. In which case we
        dispose of all data in accordance with our Terms of Service and Privacy
        Policy, but we will not hold it longer than 60 days.
      </Typography>
      <Typography paragraph variant="body1">
        We are aware that if you are working with EU customers, you need to be
        able to provide them with the ability to access update, retrieve and
        remove personal data. We got you! We've been set up as self service from
        the start and have always given you access to your data and your
        customers data. Our customer support team is here for you to answer any
        questions you might have about working with the API.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Contact Us
      </Typography>
      <Typography paragraph variant="body1">
        Don't hesitate to contact us if you have any questions.
      </Typography>
      <Typography paragraph variant="body1">
        <ul>
          <li>Via Email: support@invifo.com</li>
          <li>Via this Link: https://www.invifo.com/contact-us</li>
        </ul>
      </Typography>
    </React.Fragment>
  );
}

export default TermsConditions;
